import { createFileRoute } from "@tanstack/react-router";
import { useRef } from "react";
import { useAuth } from "@/auth";
import { AppShell } from "@/components/app-shell";
import { setAccessTokenGetter } from "@/lib/writ-key";

function AppIndex() {
  const { user, isLoading, signIn, getAccessToken } = useAuth();

  // Wire up access token getter once
  const tokenGetterSet = useRef(false);
  if (!tokenGetterSet.current) {
    setAccessTokenGetter(getAccessToken);
    tokenGetterSet.current = true;
  }

  // Skip auth in dev mode
  if (import.meta.env.DEV) {
    return (
      <AppShell
        user={{
          id: "dev-user",
          email: "dev@misplot.com",
          firstName: "Dev",
        }}
      />
    );
  }

  if (isLoading) {
    return <div className="h-screen bg-background" />;
  }

  if (!user) {
    void signIn();
    return <div className="h-screen bg-background" />;
  }

  return (
    <AppShell
      user={{
        id: user.id,
        email: user.email,
        firstName: user.firstName ?? undefined,
        lastName: user.lastName ?? undefined,
        profilePictureUrl: user.profilePictureUrl ?? undefined,
      }}
    />
  );
}

export const Route = createFileRoute("/_auth/")({
  component: AppIndex,
});
